import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import AskAIWidget from './AskAIWidget';
import { useAuth } from '../../../contexts/AuthContext';

const AskAIFloatingButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { profile } = useAuth();

  useEffect(() => {
    const handleEsc = (e) => { if (e?.key === 'Escape') setIsOpen(false); };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 right-6 z-[997] flex items-center space-x-2 bg-violet-600 hover:bg-violet-700 text-white px-4 py-3 rounded-2xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200 group"
        aria-label="Open Ask AI"
      >
        <div className="w-6 h-6 flex items-center justify-center">
          <Icon name="Sparkles" size={18} color="white" />
        </div>
        <span className="text-sm font-semibold">Ask AI</span>
        <div className="w-2 h-2 bg-violet-300 rounded-full animate-pulse" />
      </button>

      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-[998] backdrop-blur-sm"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Drawer */}
      <div
        className={`fixed bottom-0 right-0 z-[999] w-full sm:w-[420px] bg-background border-l border-t border-border rounded-tl-2xl shadow-2xl transition-transform duration-300 ease-out ${
          isOpen ? 'translate-y-0' : 'translate-y-full sm:translate-x-full sm:translate-y-0'
        }`}
        style={{ maxHeight: '85vh' }}
      >
        {/* Drawer Header */}
        <div className="flex items-center justify-between px-5 py-4 bg-violet-600 rounded-tl-2xl">
          <div className="flex items-center space-x-3">
            <div className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center">
              <Icon name="Sparkles" size={18} color="white" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-white">Wilcart AI Assistant</h3>
              <p className="text-xs text-violet-200">Powered by Wilcart AI</p>
            </div>
          </div>
          <button
            onClick={() => setIsOpen(false)}
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/20 transition-colors"
          >
            <Icon name="X" size={18} color="white" />
          </button>
        </div>

        {/* Widget Content */}
        <div className="p-5 overflow-y-auto" style={{ maxHeight: 'calc(85vh - 72px)' }}>
          <AskAIWidget orgId={profile?.org_id} />
        </div>
      </div>
    </>
  );
};

export default AskAIFloatingButton;
